import React, { FC } from 'react';
import { useAppSelector } from '../../../../hooks/redux';
import ScratchCardLight from '../../../../assets/images/cards/ScratchCardLight.png';
import ScratchCardDark from '../../../../assets/images/cards/ScratchCardDark.png';

export const ScratchCard: FC = () => {
  const { theme } = useAppSelector((state) => state.appReducer);

  const getIcon = (colorTheme: string) => {
    switch (colorTheme) {
      case 'light': {
        return ScratchCardLight;
      }
      case 'dark': {
        return ScratchCardDark;
      }
      default: {
        return ScratchCardLight;
      }
    }
  };
  return <img src={getIcon(theme)} alt="scratch card" />;
};
